"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Award, Clock, Palette, Shield, Users, Wrench } from "lucide-react";
export default function LuxuryRenovationsUSP() {
  const usps = [{
    id: 1,
    icon: Award,
    title: "Premium Quality",
    description: "We use only the finest materials and craftsmanship to deliver exceptional results that stand the test of time."
  }, {
    id: 2,
    icon: Palette,
    title: "Custom Design",
    description: "Every project is tailored to your unique vision, ensuring a space that truly reflects your personal style."
  }, {
    id: 3,
    icon: Users,
    title: "Expert Team",
    description: "Our experienced professionals bring years of expertise and dedication to every \n renovation project."
  }, {
    id: 4,
    icon: Clock,
    title: "Timely Delivery",
    description: "We respect your schedule and complete projects on time without \n compromising on quality."
  }, {
    id: 5,
    icon: Shield,
    title: "Full Warranty",
    description: "All our work is backed by comprehensive warranties for your complete peace of mind."
  }, {
    id: 6,
    icon: Wrench,
    title: "End-to-End Service",
    description: "From initial consultation to final touches, we handle every aspect of your \renovation journey."
  }];
  return <section id="luxuryrenovationsusp" className="bg-background text-foreground">
      <div className="container mx-auto max-w-[78rem] px-4 py-16 md:py-24">
        <div className="text-center mb-12">
          <p className="text-sm font-normal mb-4 tracking-wider uppercase leading-relaxed !text-[hsl(32,29%,42%)]">
            WHY <span className="font-semibold !text-[hsl(32,29%,42%)]">KS LUXURY RENOVATIONS</span>
          </p>
          <h2 className="text-foreground font-bold font-display leading-normal !text-5xl">The Standard of Quiet Luxury</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {usps.map((usp, i) => {
          const Icon = usp.icon;
          return <Card key={usp.id} data-index={i} className="card hover-lift border border-border">
                <CardHeader className="pb-4 flex flex-col items-center">
                  <div className="p-3 rounded-lg bg-accent/10 mx-auto mb-4">
                    <Icon className="size-6 text-[#a03223]" />
                  </div>
                  <CardTitle className="text-xl font-display text-foreground mb-2 leading-relaxed text-center">
                    {usp.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="whitespace-pre-line text-base text-foreground text-center !h-[96px] ![margin:-30px_0px_0px_0px] leading-relaxed">
                    {usp.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>

    <div className="w-full bg-[hsl(32,29%,42%)] text-foreground ![padding:96px_0px_120px_0px]">
  <div className="mx-auto max-w-3xl px-4 text-center">
<h2 className="font-display font-bold mb-6 text-5xl leading-snug text-white">
  Let's Create a Space That Reflects You
</h2>
    <p className="text-lg mb-8 leading-loose !text-white md:text-xl">
  Whether you are renovating a private residence or a professional space,
  <br />
  <strong>KS LUXURY RENOVATIONS</strong> delivers results defined by quality and trust.
</p>

    <Link to="/ContactPage">
     <Button size="lg" className="text-sm text-primary-foreground inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs has-[>svg]:px-4 bg-accent font-semibold h-[60px] rounded-full shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] !m-0 !text-[hsl(0,0%,100%)] !text-lg !p-6 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover hover:shadow-strong hover:-translate-y-1 active:translate-y-0">Contact Us</Button>
    </Link>
  </div>
    </div>

    </section>;
}